module.exports = __webpack_public_path__ + "media/assets/images/claim-places/mfc-89a280b5813834cfdefef50a43370d4b.svg";